import DrawerButton from "components/form/DrawerButton";
import Error from "components/form/Error";
import LabelArea from "components/form/LabelArea";
import Title from "components/form/Title";
import useOnewayPickupPeriodicHikeDaySubmit from 'hooks/OnewayPeriodicHikeDaySubmit'
import DynamicOnewayPeriodicHikeDayInput from "components/form/DynamicOnewayPeriodicHikeDayInput";
import OnewayPickupSelectCity from "components/form/OneWayselectCity";
import InputAreaDate from "components/form/InputAreaDate";
import React from "react";
import Scrollbars from "react-custom-scrollbars-2";
// import DateRangePicker from "components/form/InputDateRangePicker";

const OnewayPeriodicHikeDayDrawer = ({ id }) => {
  const {
    setSelectedOptions,
    selectedOptions,
    handleVehicleCategoryChange,
    setDataInput,
    dataInput,
    handleChangeInput,
    register,
    handleSubmit,
    fromCity,
    toCity,
    onSubmit,
    handleFromCityChange,
    handleToCityChange,
    selectedVehicleCategory,
    trigger,
    errors,
    startDate,
    endDate,
    setEndDate,
    handleStartDateChange,
  } = useOnewayPickupPeriodicHikeDaySubmit(id);
  return (
    <>
      <div className="w-full relative p-6 border-b border-gray-100 bg-gray-50 dark:border-gray-700 dark:bg-gray-800 dark:text-gray-300">
        {id ? (
          <Title
            title={"Edit Oneway Pickup Periodic Hike Day"}
            description={""}
          />
        ) : (
          <Title
            title={"Add Oneway Pickup Periodic Hike Day"}
            description={""}
          />
        )}
      </div>
      <Scrollbars className="w-full md:w-7/12 lg:w-8/12 xl:w-8/12 relative dark:bg-gray-700 dark:text-gray-200 mb-20">
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="px-5 pt-4 flex-grow scrollbar-hide w-full max-h-full">
            <div className="grid grid-cols-12 gap-5 mb-6 items-center">
              <div className="col-span-12" style={{ display: "flex" }}>
                <div style={{ width: "100%" }} >
                  <LabelArea label={"From City"} />
                  <OnewayPickupSelectCity
                    register={register}
                    name="from_city"
                    label="From City"
                    selectedCity={fromCity}
                    handleCityChange={handleFromCityChange}
                  />
                </div>
                <div style={{ width: "100%" }} >
                  <LabelArea label={"To City"} />
                  <OnewayPickupSelectCity
                    register={register}
                    name="to_city"
                    label="To City"
                    selectedCity={toCity}
                    handleCityChange={handleToCityChange}
                  />
                </div>
                <Error errorName={errors.name_of_aiport} />
              </div>

              <div className="col-span-6">
                <LabelArea label="Start Date" />
                <InputAreaDate
                  trigger={trigger}
                  register={register}
                  label="Start Date"
                  name="start_date"
                  type="date"
                  value={startDate}
                  onChange={handleStartDateChange}
                  min={new Date()}
                />
                <Error errorName={errors.start_date} />
              </div>

              <div className="col-span-6">
                <LabelArea label="End Date" />
                <InputAreaDate
                  trigger={trigger}
                  register={register}
                  label="End Date"
                  name="end_date"
                  type="date"
                  value={endDate}
                  placeholder="dd/mm/yyyy"
                  onChange={(event) => setEndDate(event)}
                  min={
                    startDate
                      ? startDate < new Date()
                        ? new Date()
                        : startDate
                      : new Date()
                  }
                />
                <Error errorName={errors.end_date} />
              </div>
            </div>

            <DynamicOnewayPeriodicHikeDayInput
              register={register}
              trigger={trigger}
              errors={errors}
              dataInput={dataInput}
              setDataInput={setDataInput}
              handleChange={handleChangeInput}
              selectedOptions={selectedOptions}
              setSelectedOptions={setSelectedOptions}
              handleVehicleCategoryChange={handleVehicleCategoryChange}
              selectedVehicleCategory={selectedVehicleCategory}
            />
          </div>

          <DrawerButton id={id} title={id ? "Update" : "Submit"} />
        </form>
      </Scrollbars>
    </>
  );
};

export default OnewayPeriodicHikeDayDrawer;
